import { render, staticRenderFns } from "./VisualProcessIndex.vue?vue&type=template&id=07b0aeb8&scoped=true&"
import script from "./VisualProcessIndex.vue?vue&type=script&lang=js&"
export * from "./VisualProcessIndex.vue?vue&type=script&lang=js&"
import style0 from "./VisualProcessIndex.vue?vue&type=style&index=0&id=07b0aeb8&prod&lang=less&scoped=true&"
import style1 from "./VisualProcessIndex.vue?vue&type=style&index=1&id=07b0aeb8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b0aeb8",
  null
  
)

export default component.exports